import dayjs from "dayjs";

const DATE_RANGE = 12;
export function getMonths(offset) {
  const beginDate = dayjs().startOf("month").add(offset, "month");
  let months = [beginDate];
  for (let i = 1; i < DATE_RANGE; i++) {
    const date = beginDate.add(i, "month");
    months = [...months, date];
  }
  return months;
}
